import React from 'react';
import { OneTrustCategoryIds } from './types';

export const ONETRUST_SCRIPT_DEFAULT_TYPE = 'text/plain';

export const TEST = '-test';

export const PAGES_WITHOUT_OVERLAY = [
  '/cookie-policy',
  '/privacy-policy',
  '/terms',
];

export const PREVENT_ONETRUST_OVERLAY_CSS = (
  <style type="text/css">
    {'body .onetrust-pc-dark-filter {display: none !important;}'}
  </style>
);

export enum OneTrustCookieNames {
  optanonConsent = 'OptanonConsent',
  optanonAlertBoxClosed = 'OptanonAlertBoxClosed',
}

// The "Strictly-necessary" (C0001) category is always enabled.
export const DEFAULT_ACTIVE_CATEGORIES = [
  OneTrustCategoryIds.strictlyNecessary,
];
